import $ from 'jquery'
require('jquery-match-height')

const matchNewsHeight = () => {
	if ($('.news-events-block').hasClass('has-calendar')) {
		return
	}
	$('.news-title').matchHeight()
	$('.news-excerpt').matchHeight()
}

$(document).ready(function() {
	matchNewsHeight()
})

export default matchNewsHeight
